import request from '@/utils/request'

export const getProvider = async (id: string) =>
    request({
        url: 'provider/' + id,
        method: 'get'
    });
